"use client";

import { useEffect } from "react";
import { useTable } from "spacetimedb/react";
import { tables } from "@/module_bindings";
import { markViewsApplied } from "@/lib/boot-state";

/**
 * Boot-time subscribe-everything (spec §3): one subscription per
 * client-facing view, so every route's data is live before the boot overlay
 * fades and no route shows a first-visit loader. Page hooks keep their own
 * useTable calls — the SDK unions subscriptions and shares one client cache.
 *
 * org_playbook_sync / org_glaci_sync are admin-gated and simply return zero
 * rows for non-admins. svc_* views are service-identity-only and excluded.
 */
export default function BootstrapSubscriptions() {
  const applied = [
    useTable(tables.my_user)[1],
    useTable(tables.my_organizations)[1],
    useTable(tables.my_memberships)[1],
    useTable(tables.my_pending_orgs)[1],
    useTable(tables.org_members)[1],
    useTable(tables.org_users)[1],
    useTable(tables.org_api_keys)[1],
    useTable(tables.org_tax_exemptions)[1],
    useTable(tables.org_subscriptions)[1],
    useTable(tables.org_playbooks)[1],
    useTable(tables.org_glaci_tags)[1],
    useTable(tables.org_playbook_tags)[1],
    useTable(tables.org_opportunities)[1],
    useTable(tables.org_opportunity_tags)[1],
    useTable(tables.org_opportunity_accept_playbooks)[1],
    useTable(tables.org_playbook_sync)[1],
    useTable(tables.org_glaci_sync)[1],
  ];
  const allApplied = applied.every(Boolean);

  useEffect(() => {
    if (allApplied) markViewsApplied();
  }, [allApplied]);

  return null;
}
